import { Injectable } from '@angular/core';
import { PAGE_PERMISSIONS } from '../guards/permissions.config';
import { AuthService } from './auth.service';
import { PermissionType } from '../models/enum/permission.enum';

@Injectable({
    providedIn: 'root',
})
export class PermissionsService {

    constructor(private authService: AuthService) { }

    async hasPermission(permission: PermissionType): Promise<boolean> {
        const userPermissions = await this.getUserPermissions();
        return userPermissions.includes(permission);
    }

    async hasAnyPermission(permissions: PermissionType[]): Promise<boolean> {
        const userPermissions = await this.getUserPermissions();
        return permissions.some(permission => userPermissions.includes(permission));
    }

    async hasAccess(page: string): Promise<boolean> {
        if (!page || !PAGE_PERMISSIONS.find(p => p.page == page)) {
            return false;
        }
        try {
            const pagePermissions = PAGE_PERMISSIONS.find(p => p.page == page).permissions;
            const userPermissions = await this.getUserPermissions();
            return pagePermissions.some(permission => userPermissions.includes(permission));
        } catch (e) {
            console.error(e);
            return false;
        }
    }

    private async getUserPermissions(): Promise<PermissionType[]> {
        const profile = await this.authService.getUserProfile();
        return profile.permissions.map(permission => permission.name);
    }
}